import DateTime, { MomentAdapter } from '@/services/DateTime'

export default function (container) {
  container.singleton('dateTime', (containerObj) => {
    return new DateTime(
      new MomentAdapter(containerObj.make('moment'))
    )
  })
}
